/**
 * خدمة طباعة باركود المنتجات
 * توفر وظائف للتواصل مع واجهة برمجة التطبيق (API) لطباعة باركود المنتجات
 */
import api from './api';
import axios from 'axios';

// تعريف الأنواع مباشرة لتجنب مشاكل الاستيراد
export type PrintSettings = {
  paperWidth: number;
  paperHeight: number;
  marginTop: number;
  marginRight: number;
  marginBottom: number;
  marginLeft: number;
  labelsPerRow: number;
  showProductName: boolean;
  showVariantAttributes: boolean;
  showBarcode: boolean;
  showPrice: boolean;
  showCompanyName: boolean;
  showInvoiceNumber: boolean;
  barcodeWidth: number;
  barcodeHeight: number;
  fontSize: number;
  companyName: string;
  selectedPriceType: string;
};

// تعريف الأنواع الأخرى المطلوبة
export interface ProductVariant {
  _id: string;
  attributes: Record<string, string>;
  barcode?: string;
  price: number;
  wholesalePrice?: number;
  customPrice1?: number;
  customPrice2?: number;
  quantity?: number;
  selected?: boolean;
}

export interface Product {
  _id: string;
  name: string;
  code?: string;
  variants: ProductVariant[];
}

export interface Invoice {
  _id: string;
  invoiceNumber: string;
  date: string;
  customer?: {
    name: string;
  };
  total?: number;
}

/**
 * جلب قائمة الفواتير المكتملة للاختيار منها
 */
export const getInvoicesForBarcodes = async (page = 1, limit = 50, search?: string) => {
  try {
    let url = `/product-barcodes/invoices?page=${page}&limit=${limit}`;
    
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices for barcodes:', error);
    throw error;
  }
};

/**
 * البحث عن فاتورة برقمها
 */
export const getInvoiceByNumber = async (invoiceNumber: string) => {
  try {
    const response = await api.get(`/product-barcodes/invoice-by-number/${encodeURIComponent(invoiceNumber)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoice by number:', error);
    throw error;
  }
};

/**
 * جلب منتجات ومتغيرات فاتورة محددة لطباعة الباركود
 */
export const getInvoiceProductsForBarcodes = async (invoiceId: string) => {
  try {
    const response = await api.get(`/product-barcodes/invoices/${invoiceId}/products`);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoice products for barcodes:', error);
    throw error;
  }
};

/**
 * حفظ إعدادات طباعة الباركود للمستخدم
 */
export const saveBarcodeSettings = async (settings: PrintSettings) => {
  try {
    const response = await api.post('/product-barcodes/settings', settings);
    return response.data;
  } catch (error) {
    console.error('Error saving barcode settings:', error);
    throw error;
  }
};

/**
 * جلب إعدادات طباعة الباركود للمستخدم
 */
export const getBarcodeSettings = async () => {
  try {
    const response = await api.get('/product-barcodes/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching barcode settings:', error);
    // إرجاع إعدادات افتراضية في حالة الخطأ
    return {
      success: false,
      settings: {
        paperWidth: 50,
        paperHeight: 30,
        marginTop: 5,
        marginRight: 5,
        marginBottom: 5,
        marginLeft: 5,
        labelsPerRow: 2,
        showProductName: true,
        showVariantAttributes: true,
        showBarcode: true,
        showPrice: true,
        showCompanyName: true,
        showInvoiceNumber: true,
        barcodeWidth: 2,
        barcodeHeight: 50,
        fontSize: 10,
        companyName: 'اسم الشركة',
        selectedPriceType: 'retailPrice'
      }
    };
  }
};